import moment from 'moment'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { useLocation } from 'react-router-dom'
import { useEffect, useMemo, useState } from 'react'
import {
  useLazyGetCustomerCouponsQuery,
  useDeleteCostumerCouponsMutation,
  useAssignCostumerCouponsMutation,
} from '../../../../../services/cellcast'
import AssignCoupon from './modal/AssignCoupon'
import { toast } from 'react-toastify'

const UserCoupon = () => {
  const location = useLocation()
  const { userProp } = location.state || ({} as any)
  const [deletingId, setDeletingId] = useState<string | null>(null)
  const [addCoupon, setAddCoupon] = useState(false)

  const userDataState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const ProfileDetatileState = userProp?.user ? userProp.user : userDataState

  const [fetchCoupon, { isLoading, data }] = useLazyGetCustomerCouponsQuery()
  const [deleteCoupon] = useDeleteCostumerCouponsMutation()
  const [updateAssignedUser] = useAssignCostumerCouponsMutation()

  const handleDelete = async (couponId: string) => {
    try {
      setDeletingId(couponId)
      await deleteCoupon({
        userId: ProfileDetatileState?._id,
        couponId,
      }).unwrap()

      fetchCoupon({ userId: ProfileDetatileState?._id })
    } catch (err: any) {
      console.error('Delete failed', err)
      toast.error(err?.data?.message || 'Something went wrong')
    } finally {
      setDeletingId(null)
      toast.success('request is being processed')
    }
  }

  const handleSubmit = (couponId: string) => {
    updateAssignedUser({
      userId: ProfileDetatileState?._id,
      couponId: couponId
    })
      .then((res: any) => {
        if ('data' in res) {
          if (res.data?.error && Object.keys(res.data?.error).length > 0) {
            toast.error(res?.data?.message)
          } else {
            toast.success('request is being processed')
          }
        } else if ('error' in res) {
          toast.error(res.error?.data?.message || 'Something went wrong')
        }
      }).finally(() => {
        setAddCoupon(false)
        fetchCoupon({ userId: ProfileDetatileState?._id })
      })
  }

  useEffect(() => {
    fetchCoupon({
      userId: ProfileDetatileState?._id
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const AssignCouponModal = useMemo(
    () => (
      <AssignCoupon
        show={addCoupon}
        handleSubmit={(couponId: string) => handleSubmit(couponId)}
        handleClose={() => {
          setAddCoupon(false)
        }}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [addCoupon]
  )

  return (
    <>
      {AssignCouponModal}
      <div className='col-md-12'>
        <div className='card mb-6'>
          <div className='card-header card-header-stretch border-bottom-0 d-flex justify-content-between align-items-center'>
            <div className='card-title d-flex align-items-center'>
              <h3 className='fw-bolder m-0 text-gray-800'>Coupon</h3>
            </div>
            <button
              className='btn btn-sm btn-light-primary'
              onClick={() => setAddCoupon(true)}
            >
              <span className='indicator-label'>Add Coupon</span>
            </button>
          </div>
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bolder text-muted bg-light text-bolder table-row-gray-200 border-bottom border-top'>
                      <th className='ps-4 min-w-125px rounded-start fw-bolder'>Coupon</th>
                      <th className='min-w-100px fw-bolder'>Assigned</th>
                      <th className='min-w-100px fw-bolder'>Expired</th>
                      <th className='min-w-100px fw-bolder'>Purchase Amount</th>
                      <th className='min-w-100px fw-bolder'>Commission</th>
                      <th className='min-w-100px fw-bolder'>Status</th>
                      <th className='min-w-150px  rounded-end fw-bolder text-end pe-10'>Actions</th>
                    </tr>
                  </thead>
                  <tbody className='p-5'>
                    {!isLoading && data?.data?.map((item: any, idx: number) => {
                      const badgeClass = clsx('badge', {
                        'badge-light-success': item?.status === 'applied',
                        'badge-light-warning': item?.status === 'unused',
                        'badge-light-danger': item?.status === 'expired',
                      })

                      return (
                        <tr key={idx}>
                          <td className='ps-3 table-row-gray-200 border-bottom border-top ps-5'>
                            {item?.code}
                          </td>
                          <td className='ps-3 table-row-gray-200 border-bottom border-top ps-5'>
                            {moment(item?.customers?.find((cust: any) => cust?.userId?._id === ProfileDetatileState?._id)?.assignedAt).format('DD/MMM/YYYY HH:mm')}
                          </td>
                          <td className='ps-3 table-row-gray-200 border-bottom border-top ps-5'>
                             {moment(item?.customers?.find((cust: any) => cust?.userId?._id === ProfileDetatileState?._id)?.expiredAt).format('DD/MMM/YYYY HH:mm')}
                          </td>
                          <td className='ps-3 table-row-gray-200 border-bottom border-top ps-5'>
                            ${item?.amountSpent}
                          </td>
                          <td className='ps-3 table-row-gray-200 border-bottom border-top'>
                            {item?.commisionRate}%
                          </td>
                          <td className='ps-3 table-row-gray-200 border-bottom border-top'>
                            <div className={badgeClass}>
                              {item?.status?.toUpperCase()}
                            </div>
                          </td>
                          <td className='table-row-gray-200 border-top text-end pe-5'>
                            <button
                              disabled={item?.status !== 'unused' || deletingId === item?._id}
                              onClick={() => handleDelete(item?._id)}
                              className='btn btn-sm btn-light btn-active-light-primary me-3 fw-500'
                            >
                              {deletingId === item?._id ? 'Removing...' : 'Remove'}
                            </button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserCoupon
